(function () {
  'use strict';
  // Campaign lines have whole-bundle controls. Ordinary cart rows keep their
  // existing controls. These UI rules supplement the server checkout validation.
  let busy = false;
  document.addEventListener('click',async event=>{
    const button=event.target.closest('[data-et-offer-remove]');
    if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy) return;
    const root=window.Shopify?.routes?.root || '/';
    const status=document.querySelector('[data-et-offer-cart-status]');
    const checkout=[...document.querySelectorAll('[name="checkout"],.additional-checkout-buttons')];
    busy=true; button.disabled=true;
    checkout.forEach(node=>{node.inert=true;});
    try {
      const response=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if(!response.ok) throw new Error('cart-fetch');
      const cart=await response.json();
      const selected=cart.items.filter(item=>button.dataset.etOfferRemove==='gift'
        ? item.key===button.dataset.key
        : item.properties?._et_bundle_id===button.dataset.group);
      if(!selected.length) { location.reload(); return; }
      const update=await fetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({updates:Object.fromEntries(selected.map(item=>[item.key,0]))})});
      if(!update.ok) throw new Error('cart-update');
      const after=await update.json();
      if(after.items.some(item=>selected.some(old=>old.key===item.key))) throw new Error('cart-update');
      location.reload();
    } catch (_) {
      if(status) status.textContent=status.dataset.error;
      button.disabled=false;
    } finally {
      busy=false; checkout.forEach(node=>{node.inert=false;});
    }
  },true);
})();
